import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { AwardModel } from 'entities';
import {
    createStrapiMediaUrl,
    useAppSelector,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchAwardsThunk,
} from 'shared/lib';
import BaseError from '../../../utils/base-error';

type AwardsBlockState = {
    loaded: boolean
    awards: AwardModel[],
    errors: BaseError[]
}

const initialState: AwardsBlockState = {
    loaded: false,
    awards: [],
    errors: [],
};

export const awardsBlockSlice = createSlice({
    name: 'awardsBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAwardsThunk.fulfilled, (state, action) => {
            const response = action.payload;

            if (response instanceof BaseError) {
                state.errors.push(response);
            } else {
                state.awards = response.data.data.map(
                    ({
                        slug,
                        name,
                        description,
                        image,
                        years,
                    }) => ({
                        uid: slug,
                        name,
                        description,
                        image: image && {
                            url: createStrapiMediaUrl(image.url),
                        },
                        years: years?.map(({ year }) => year) || [],
                    }),
                );
                state.loaded = true;
            }
        });
    },
});

export const useAwardsBlockState = () => useAppSelector((store) => store.awardsBlock);
